import Cookies from 'js-cookie';
import api, { baseAPIURL } from './api';

export const SAML_SSO_LOGIN_URL = `${baseAPIURL}/saml_auth/foodles/login/`;

const LOGIN_URL = '/api/auth/login/';
const LOGOUT_URL = '/api/auth/logout/';
const ISLOGGEDIN_COOKIE = 'isloggedin';
const SESSIONID_COOKIE = 'sessionid';
const CSRFTOKEN_COOKIE = 'csrftoken';

export interface User {
  id: number;
  client: number;
  fullname: string;
  last_login: string;
  is_superuser: boolean;
  username: string;
  first_name: string;
  last_name: string;
  email: string;
  is_staff: boolean;
  is_active: true;
  date_joined: string;
}

export async function login(username: string, password: string): Promise<boolean> {
  try {
    const response = await api.post<User>(LOGIN_URL, {
      username: username.replace(/ /g, '').toLowerCase(),
      password,
    });
    return !!response.data?.id;
  } catch (err) {
    return false;
  }
}

export function loginWithGoogle(): void {
  const next = encodeURIComponent(window.location.href);
  window.location.assign(`${SAML_SSO_LOGIN_URL}?next_url=${next}`);
}

export function isLoggedIn(): boolean {
  return (
    (!!Cookies.get(ISLOGGEDIN_COOKIE) || !!Cookies.get(SESSIONID_COOKIE)) &&
    !!Cookies.get(CSRFTOKEN_COOKIE)
  );
}

export function logout(): void {
  api.post(LOGOUT_URL).catch(() => {});
}
